import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  AvatarGroup, Avatar, Box, Tooltip,
} from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { DataValueMap } from 'Helpers/Testing';

const CollectionAvatarGroup = ({
  className,
  collection,
  max,
}) => {
  const resources = collection.resources().list();
  const tooltipText = (
    <React.Fragment>
      {resources.map(member => (
        <Box key={member.id()}>
          {member.attr('name')}
        </Box>
      ))}
    </React.Fragment>
  );

  const avatarGroupTestAttributes = DataValueMap.init('avatar-group').build();

  const getAvatarTestAttributes = (avatar) => {
    return (
      DataValueMap.init('avatar')
        .append(DataValueMap.keyMap.dataResourceId, avatar.id())
        .build()
    );
  };

  return (
    <Tooltip
      title={tooltipText}
      placement="top"
    >
      <AvatarGroup
        className={className}
        max={max}
        {...avatarGroupTestAttributes}
      >
        {resources.map((avatar) => {
          const fallbackInitial = avatar.attr('name')[0];
          return (
            <Avatar
              color={'primaryBlue'}
              key={avatar.id()}
              alt={avatar.attr('name')}
              src={avatar.relationship(fr.relationships.profileImage.name)?.link('related')?.url()}
              {...getAvatarTestAttributes(avatar)}
            >
              {fallbackInitial}
            </Avatar>
          );
        })}
      </AvatarGroup>
    </Tooltip>
  );
};

CollectionAvatarGroup.defaultProps = {
  className: '',
  max: 3,
};

CollectionAvatarGroup.propTypes = {
  className: PropTypes.string,
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
  max: PropTypes.number,
};

export default CollectionAvatarGroup;
